import { useCart } from "@/context/CartContext";
import { fileUrl, formatBRL } from "@/lib/api";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Minus, Plus, Trash2 } from "lucide-react";

export default function CartPage() {
  const { items, updateQty, remove, subtotal } = useCart();
  const nav = useNavigate();
  return (
    <div className="mx-auto max-w-7xl px-5 lg:px-8 py-14">
      <div className="overline-label">Checkout</div>
      <h1 className="font-display text-5xl tracking-tighter text-white mt-3">Seu carrinho</h1>

      {items.length === 0 ? (
        <div className="mt-14 text-center text-zinc-500 py-16 border border-white/10" data-testid="cart-page-empty">
          <p className="font-display text-2xl text-white">Nada por aqui ainda</p>
          <p className="mt-2 text-sm">Adicione produtos para começar.</p>
          <Button asChild className="mt-6 bg-white text-black hover:bg-zinc-200 h-12 px-8 uppercase tracking-widest text-xs">
            <Link to="/">Continuar comprando</Link>
          </Button>
        </div>
      ) : (
        <div className="grid lg:grid-cols-3 gap-10 mt-10">
          <div className="lg:col-span-2 space-y-6">
            {items.map((it) => {
              const key = `${it.product_id}|${it.size || ""}|${it.color || ""}`;
              return (
                <div key={key} className="flex gap-5 border-b border-white/5 pb-6">
                  <Link to={`/produto/${it.product_id}`} className="shrink-0 h-32 w-24 bg-black overflow-hidden border border-white/10">
                    {it.image ? <img src={fileUrl(it.image)} alt={it.name} className="w-full h-full object-cover" /> : null}
                  </Link>
                  <div className="flex-1 min-w-0">
                    <Link to={`/produto/${it.product_id}`} className="text-white font-medium hover-underline">{it.name}</Link>
                    <div className="text-xs text-zinc-500 mt-1">
                      {it.size && <span>Tam: {it.size}</span>}
                      {it.size && it.color && <span> · </span>}
                      {it.color && <span>Cor: {it.color}</span>}
                    </div>
                    <div className="flex items-center gap-4 mt-4">
                      <div className="inline-flex items-center border border-white/15">
                        <button onClick={() => updateQty(key, it.quantity - 1)} className="h-9 w-9 grid place-items-center hover:bg-white/5"><Minus size={14} /></button>
                        <span className="min-w-8 text-center text-sm text-white">{it.quantity}</span>
                        <button onClick={() => updateQty(key, it.quantity + 1)} className="h-9 w-9 grid place-items-center hover:bg-white/5"><Plus size={14} /></button>
                      </div>
                      <button onClick={() => remove(key)} className="text-zinc-500 hover:text-white flex items-center gap-2 text-xs"><Trash2 size={14} /> Remover</button>
                    </div>
                  </div>
                  <div className="font-display text-lg text-white">{formatBRL(it.price * it.quantity)}</div>
                </div>
              );
            })}
          </div>
          <div className="border border-white/10 p-6 h-fit sticky top-24">
            <div className="overline-label mb-5">Resumo</div>
            <div className="flex justify-between text-sm text-zinc-300"><span>Subtotal</span><span className="font-display text-white">{formatBRL(subtotal)}</span></div>
            <div className="flex justify-between text-sm text-zinc-500 mt-2"><span>Frete</span><span>calculado no checkout</span></div>
            <div className="border-t border-white/10 mt-6 pt-6 flex justify-between items-baseline">
              <span className="text-zinc-300 text-sm">Total parcial</span>
              <span className="font-display text-2xl text-white">{formatBRL(subtotal)}</span>
            </div>
            <Button onClick={() => nav("/checkout")} data-testid="cart-page-checkout-btn" className="w-full mt-6 bg-white text-black hover:bg-zinc-200 h-13 uppercase tracking-widest text-xs">
              Ir para checkout
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
